module.exports = new __parcel__URL__("snake.3ead898b.svg").toString();